import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Expo Regions',
  basePath: '/expo-regions',
  reorderable: true,
  columns: [
    { key: 'continent_name', label: 'Continent' },
    { key: 'region', label: 'Region' },
  ],
  fields: [
    { key: 'continent', label: 'Continent', type: 'async-select',
      optionsUrl: '/expo-continents/options', required: true },
    { key: 'region', label: 'Region', type: 'text', required: true },
  ],
});
